import { render, staticRenderFns } from "./onlinefeed.vue?vue&type=template&id=2abec268&scoped=true&"
import script from "./onlinefeed.vue?vue&type=script&lang=js&"
export * from "./onlinefeed.vue?vue&type=script&lang=js&"
import style0 from "./onlinefeed.vue?vue&type=style&index=0&id=2abec268&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2abec268",
  null
  
)

export default component.exports